import React, { useState } from 'react';
import { Box, Grid, Button, TextField, Card, CardContent, Typography, IconButton, Input, Paper } from '@mui/material';
import { Folder as FolderIcon, FileOpen, Delete, LibraryBooks, Article } from '@mui/icons-material';

interface DocumentProps {
    title: string;
    description: string;
    lastModified?: string;
    size?: string;
    file: File | null;
    view?: 'grid' | 'list';
  }

const Document: React.FC<DocumentProps> = ({
    title,
    description,
    lastModified = '-------------------------',
    size = '-----------------------',
    file,
    view = 'list'
}) => {
return (
    <>
        <Paper elevation={3} sx={{mt: 2, padding: 2, borderRadius: 3, display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}} onClick={() => console.log('Folder Clicked')}>
            <Box color={'text.secondary'} sx={{p: 0.5,  display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                <FileOpen />
                <Typography sx={{ml:2.5}} alignSelf='center' variant="body1" color="textSecondary">{title}</Typography>
            </Box>
            <Typography alignSelf='center' variant="body1" color="textSecondary">{lastModified}</Typography>
            <Typography alignSelf='center' variant="body1" color="textSecondary">{size}</Typography>
        </Paper>
    </>
)

};

export default Document;
